import { useTranslation } from "react-i18next";

export function RootErrorComponent({
	reset,
}: {
	error: Error;
	reset: () => void;
}) {
	const { t } = useTranslation("error");
	return (
		<div className="flex flex-1 flex-col items-center justify-center gap-6 px-6 py-24 text-center">
			<p className="text-xs font-bold uppercase tracking-widest text-muted-foreground">
				{t("label")}
			</p>
			<h1 className="display-title text-[48px] leading-none text-foreground">
				{t("title")}
			</h1>
			<p className="max-w-sm text-sm text-muted-foreground">{t("body")}</p>
			<div className="flex items-center gap-3">
				<button
					type="button"
					onClick={reset}
					className="inline-flex h-9 items-center justify-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
				>
					{t("tryAgain")}
				</button>
				<a
					href="/"
					className="text-xs font-semibold uppercase tracking-widest text-muted-foreground/60 underline-offset-4 hover:text-foreground hover:underline transition-colors"
				>
					{t("goHome")}
				</a>
			</div>
		</div>
	);
}
